import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import { useProductListing } from '../hooks/useProductListing'

export function SelectionCount(): React.ReactElement {
  const { filterCount } = useProductListing()

  if (filterCount === 0) return <></>

  return <Count>{filterCount}</Count>
}

const Count = styled.span`
  display: inline-block;
  color: ${plume.COLORS.PRIMARY_GREY_500};
  font-size: 12px;
  font-weight: bold;
  margin-left: 3px;
`
